/* eslint-disable import/no-cycle */
import { EventCollectorPayload } from './payloads';
import { isNotProduction } from 'utils/isNotProduction';

async function fetchEventCollector(event: EventCollectorPayload) {
  // TODO: Don't test on Cypress
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (window && (window as any).Cypress) {
    return;
  }

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(sessionStorage.getItem('token') && {
        Authorization: `Basic ${sessionStorage.getItem('token')}`,
      }),
    },
    body: JSON.stringify(event),
  };

  try {
    if (import.meta.env.VITE_ANALYTICS_API)
      await fetch(import.meta.env.VITE_ANALYTICS_API, options);
  } catch (e) {
    if (isNotProduction()) {
      // eslint-disable-next-line no-console
      console.error('Event collector request failed');
    }
  }
}

export default fetchEventCollector;
